import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/yuntiicon.png'
import _imports_1 from '../../assets/imgs/top.png'
import _imports_2 from '../../assets/imgs/toolbox.png'
import _imports_3 from '../../assets/imgs/beian.png'


const _withScopeId = n => (_pushScopeId("data-v-a915793c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "footerall",
  id: "last"
}
const _hoisted_2 = { class: "relation" }
const _hoisted_3 = { class: "serve" }
const _hoisted_4 = { class: "num" }
const _hoisted_5 = { style: {"color":"rgb(155, 156, 157)"} }
const _hoisted_6 = { class: "num" }
const _hoisted_7 = { style: {"color":"rgb(155, 156, 157)"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgb(155, 156, 157)","font-size":"16px"} }, " support@ytdevops.com ", -1))
const _hoisted_9 = { class: "backall" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yunicon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_11 = { class: "name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "8H Auto Devops", -1))
const _hoisted_13 = { class: "last" }
const _hoisted_14 = { class: "QRcode" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://img.js.design/assets/img/6425419332c9a9f54152d7e7.jpg#e5a7405089e75f56f7d886ddd8711e33",
    alt: ""
  })
], -1))
const _hoisted_16 = { class: "tip" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "trademark" }
const _hoisted_20 = { class: "markone" }
const _hoisted_21 = { class: "get" }
const _hoisted_22 = { class: "com" }
const _hoisted_23 = { class: "marktwo" }
const _hoisted_24 = { class: "get" }
const _hoisted_25 = { class: "imgdiv" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_27 = { class: "com" }

import useLocale from "@/hooks/useLocale"; // 国际化hook
import { computed } from "@vue/reactivity";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'MbTheFooter',
  setup(__props) {

const store = useStore();
const lang = computed(() => store.getters.lang);
const {
  i18n: { t }, // 解构实例用具t 访问语言变量
} = useLocale();
function toMapping() {
  window.open("https://ms.ytdevops.com");
}
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
function toTool() {
  window.open(
    "https://tools.ytdevops.com/?lang=" +
      (window.localStorage.getItem("lang")
        ? window.localStorage.getItem("lang")
        : "zh")
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("footer.contact.service")), 1),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("footer.contact.china")), 1),
          _createTextVNode("  +86 138 1743 8496")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("footer.contact.overseas")), 1),
          _createTextVNode("  +65 8312 1028")
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)("footer.main.title")), 1),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)("homepage.Jumbotron.word2")), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", { onClick: toMapping }, _toDisplayString(_unref(t)("btn.tryIt")), 1),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)("homepage.Jumbotron.word3")), 1)
    ]),
    _createElementVNode("img", {
      onClick: scrollToTop,
      class: "toTop",
      src: _imports_1,
      alt: ""
    }),
    _createElementVNode("div", {
      class: "tool-box",
      onClick: toTool
    }, _hoisted_18),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)("footer.main.right")), 1),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)("footer.main.company")), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)("footer.main.icp")), 1),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)("footer.main.record")), 1)
        ])
      ])
    ])
  ]))
}
}

})